import React from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const AreaChart = ({ activeCustomerData, inactiveCustomerData }) => {
  const sanitizeData = (data) => {
    return data.map((item) => ({
      x: item?.x?.slice(0, 3) || "Unknown",
      y: item?.y ?? 0,
    }));
  };
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );

  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;
  const placeholderText = isEIPEnabled ? "Devices" : "Customers";
  const placeholderText1 = isEIPEnabled ? "Added Devices" : "Added Customers";
  const placeholderText2 = isEIPEnabled ? "Closed Devices" : "Closed Customers";

  const sanitizedActiveCustomerData = sanitizeData(activeCustomerData || []);
  const sanitizedInactiveCustomerData = sanitizeData(
    inactiveCustomerData || []
  );

  const seriesData = [
    {
      name: placeholderText1,
      data: sanitizedActiveCustomerData,
    },
    {
      name: placeholderText2,
      data: sanitizedInactiveCustomerData,
    },
  ];

  const months = sanitizedActiveCustomerData.map((item) => item.x);

  const options = {
    series: seriesData,
    colors: ["#2AB92A", "#DC3911"],
    chart: {
      type: "area",
      toolbar: {
        show: false, // Hides the toolbar
      },
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      width: 0,
    },
    xaxis: {
      type: "category",
      categories: months,
      labels: {
        style: {
          colors: "#000000",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      title: {
        // text: 'Month',
        style: {
          color: "#000",
          fontSize: "12px",
          fontWeight: "normal",
          fontFamily: "Helvetica, Arial, sans-serif",
        },
      },
    },
    yaxis: {
      tickAmount: 4,
      floating: false,
      labels: {
        offsetY: -7,
        offsetX: 0,
        style: {
          colors: "#000000",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      title: {
        text: placeholderText,
        style: {
          color: "#000",
          fontSize: "12px",
          fontWeight: "normal",
          fontFamily: "Helvetica, Arial, sans-serif",
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 100],
      },
      colors: ["#2AB92A", "#DC3911"],
    },
    tooltip: {
      x: {
        format: "yyyy",
      },
      style: {
        colors: "#04B400",
        fontSize: "12px",
        fontFamily: "Helvetica, Arial, sans-serif",
      },
      marker: {
        fillColors: ["#04B400", "#FF3232"],
      },
      fixed: {
        enabled: false,
        position: "topRight",
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "14px",
      fontFamily: "Helvetica, Arial",
      fontWeight: 400,
      formatter: (seriesName, opts) => {
        const markerStyle = `
                    display: inline-block;
                    width: 13px;
                    height: 13px;
                    margin-right: 10px;
                    border-radius: 50%;
                    background-color: ${
                      opts.w.globals.colors[opts.seriesIndex]
                    };
                `;
        return `<div style="display: inline-flex; align-items: center; margin-top: 5px;">
                            <span style="${markerStyle}"></span>
                            <span style="color: #000000;">${seriesName}</span>
                        </div>`;
      },
      markers: {
        size: 0, // Hide default markers
      },
      itemMargin: {
        horizontal: 15,
        vertical: 0,
      },
    },
    grid: {
      show: true,
      borderColor: "#888A99",
      strokeDashArray: 0,
      position: "front",
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "10px",
            itemMargin: {
              horizontal: 2,
              vertical: 0,
            },
          },
        },
      },
    ],
  };

  return (
    <div className="area-chart">
      <ReactApexChart
        options={options}
        series={seriesData}
        type="area"
        height={250}
      />
    </div>
  );
};

export default AreaChart;
